var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftFromLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M240 378.914V336H304C330.508 336 352 314.51 352 288V224C352 197.49 330.508 176 304 176H240V132.713C240 91.082 190.629 69.189 159.773 97.137L9.375 233.375C3.125 239.625 0 247.812 0 256S3.125 272.375 9.375 278.625L159.824 414.533C190.691 442.418 240 420.512 240 378.914ZM54.633 256L192 134.633V224H304V288H192V377.367L54.633 256ZM448 424V88C448 74.75 437.25 64 424 64S400 74.75 400 88V424C400 437.25 410.75 448 424 448S448 437.25 448 424Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftFromLine);
export default __webpack_public_path__ + "static/media/left-from-line.6c7766696762302d33c3771c57d48c5c.svg";
export { ForwardRef as ReactComponent };